import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useQuery } from 'convex/react'

export function useGoalReplanStatus(goalId: Id<'nodes'>) {
  return useQuery(api.replanQueue.getPendingForGoal, { goalId })
}
